//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Die.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/Expression.js";
let d=[[[0,"BuildStatus",0,0],[1,"CavityDepth",0,"Expression",0],[1,"CavityOffset",0,"Expression",0],[0,"DesignStatus",1,0],[0,"DisplayStatus",1,0],[1,"ExtensionLength",0,"Expression",0],[1,"LowerRadius",0,"Expression",0],[0,"Radius",1,0],[1,"SectionPlacement",0,"Expression",0],[0,"Step",1,0],[1,"StepDistance",0,"Expression",0],[1,"UpperRadius",0,"Expression",0]],[[["section_placement"],"SetSectionPlacement",{},1,0],[["title","value","color"],"GetExtensionAttributes",{},0,0],[["title","value","color"],"SetExtensionAttributes",{},3,0],[["title","value","color"],"GetCavityAttributes",{},0,0],[["title","value","color"],"SetCavityAttributes",{},3,0],[["extension_length"],"SetExtensionLength",{},1,0],[["step_distance"],"SetStepDistance",{},1,0],[["upper_radius"],"SetUpperRadius",{},1,0],[["lower_radius"],"SetLowerRadius",{},1,0],[["cavity_offset"],"SetCavityOffset",{},1,0],[["cavity_depth"],"SetCavityDepth",{},1,0]],[]];
SPLM.Die.ThroatChildBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Die.ThroatChildBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Die.ThroatChildBuilder.TypeOption = Object.freeze({
    "Wipe" : "Wipe", "Restrike" : "Restrike"});

export default SPLM;